import type { Editor } from "@tiptap/core";

type RichTextCommandRunner = {
  focus: () => RichTextCommandRunner;
  toggleBold: () => RichTextCommandRunner;
  toggleItalic: () => RichTextCommandRunner;
  toggleBulletList: () => RichTextCommandRunner;
  toggleOrderedList: () => RichTextCommandRunner;
  setHorizontalRule: () => RichTextCommandRunner;
  run: () => boolean;
};

function runRichTextCommand(
  editor: Editor | null,
  build: (chain: RichTextCommandRunner) => RichTextCommandRunner
): void {
  if (!editor) {
    return;
  }
  const chain = editor.chain() as never as RichTextCommandRunner;
  build(chain).run();
}

export { runRichTextCommand };
